export default __webpack_public_path__ + "static/media/tat_header_logo.5f7c61d4.png";